const firstLetterUpperCase = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const requireMsg = (field: string) => {
  return `${firstLetterUpperCase(field)} is required`;
};

export const minMsg = (field: string, min: number) => {
  return `${firstLetterUpperCase(field)} must be ${min} number long`;
};
